import constate from 'constate';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import qs from 'query-string';
import repo from 'service/repository';
import { compare } from 'utils/city-helper';
import { cooperationStateValue } from 'utils/poi-helper';
import { taipeiCityParkingCollectionId } from 'config';
import uniqBy from 'lodash/uniqBy';

const usePoi = () => {
  const location = useLocation();
  const urlId = qs.parse(location.search).ids || undefined;
  const [poiCardTags, setPoiCardTags] = useState([]);
  const [poiBannerBoards, setPoiBannerBoards] = useState();
  const [initScroll, setInitScroll] = useState(false);
  /**
   * state: init | ready
   */
  const [poiState, setPoiState] = useState('init');
  /**
   * @param('parknglots', 'gas-stations', 'car-beauty-stores','auto-repair-stores','car-wash-stores)
   */
  const [currentMode, setCurrentMode] = useState('');
  const [poiCities, setPoiCities] = useState([]);
  const [cityBy, setCityBy] = useState();
  const [poiInUse, setPoiInUse] = useState([]);
  const [poiRaw, setPoiRaw] = useState([]);
  const [poiCollections, setPoiCollections] = useState([]);
  const [poiAppMapShow, setPoiAppMapShow] = useState(false);
  const [poiAppMapOpenLinks, setPoiAppMapOpenLinks] = useState([]);
  const [poiCardTagDialogShow, setPoiCardTagDialogShow] = useState(false);
  const [poiCardTagDialogContent, setPoiCardTagDialogContent] = useState(null);

  // autopass 加油站分類
  const [gasStationFilter, setGasStationFilter] = useState('all');

  // 北市公有
  const [poiRawTaipeiSpecial, setPoiRawTaipeiSpecial] = useState([]);
  const [poiCollectionsTaipeiSpecial, setPoiCollectionsTaipeiSpecial] = useState([]);
  const [switchText, setSwitchText] = useState('全部');
  const [switching, setSwitching] = useState(false);

  const loadPoiCardTags = async () => {
    const [err, data] = await repo.fetchPoiCardTagBoards();
    if (err) return console.log(err);
    setPoiCardTags(() => data);
  };

  const loadPoiBannerBoards = async (code, filter) => {
    const [err, data] = await repo.fetchPoiBannerBoards(code);
    if (err) return console.log(err);
    const result = data[filter];
    setPoiBannerBoards(() => (result.length > 0 ? result[0] : ''));
  };

  const getIdFilteringData = async (id, sortData) => {
    let poiDescriptions = id ? id.split(',') || [] : '';
    const [err, data] = await repo.fetchPoiCollections();
    if (err) return console.log(err);
    let ids = data.filter(x => poiDescriptions.includes(x.idDescription)).map(x => x.id);
    return sortData.filter(poi => poi.collectionIds.filter(x => ids.indexOf(x) > -1).length > 0);
  };

  // pois
  const loadPois = async id => {
    let api;

    switch (currentMode) {
      case 'gas-stations':
        api = repo.fetchGasStations;
        break;
      case 'parkinglots':
        api = repo.fetchParkinglots;
        break;
      case 'car-beauty-stores':
        api = repo.fetchCarBeauty;
        break;
      case 'auto-repair-stores':
        api = repo.fetchAutoRepair;
        break;
      case 'car-wash-stores':
        api = repo.fetchCarWash;
        break;
      case 'charging-stores':
        api = repo.fetchCharging;
        break;
      default:
        break;
    }

    const [err, data] = await api();
    if (err) return console.log(err);
    const sortData = data
      .sort((a, b) => compare(a.city, b.city))
      .sort((a, b) => cooperationStateValue(a.cooperationState) - cooperationStateValue(b.cooperationState));
    const filterData = id ? await getIdFilteringData(id, sortData) : sortData;
    const taipeiSpecial =
      currentMode === 'parkinglots'
        ? filterData
            .filter(d => d.collectionIds.includes(taipeiCityParkingCollectionId()))
            .concat(filterData.filter(x => !(x.detail.city === '台北市')))
        : [];

    if (id) {
      setPoiCollections(() => filterData);
      setPoiCollectionsTaipeiSpecial(() => taipeiSpecial);
    } else {
      setPoiRaw(() => filterData);
      setPoiRawTaipeiSpecial(() => taipeiSpecial);
    }

    setPoiInUse(() => filterData);
    setSupportCities(filterData, currentMode);
  };

  const setSupportCities = (pois, mode) => {
    let cities = [];
    if (mode && mode.includes('stores')) {
      cities = uniqBy(pois, x => x.city)
        .map(x => x.city)
        .sort((a, b) => compare(a, b));
    } else {
      cities = uniqBy(pois, x => x.detail.city)
        .map(x => x.detail.city)
        .sort((a, b) => compare(a, b));
    }

    setPoiCities(() => cities);
    return cities;
  };

  const switchingTabs = tab => {
    setSwitching(true);
    if (tab !== switchText) {
      setTimeout(() => {
        const parkinglotsInUse = () => {
          if (tab === '全部') {
            return urlId ? poiCollections : poiRaw;
          } else {
            return urlId ? poiCollectionsTaipeiSpecial : poiRawTaipeiSpecial;
          }
        };
        setPoiInUse(() => parkinglotsInUse());
        setSwitchText(tab);
        setSwitching(false);
      }, 500);
    }
  };

  return {
    poiCardTags,
    poiBannerBoards,
    initScroll,
    setInitScroll,
    poiState,
    setPoiState,
    currentMode,
    setCurrentMode,
    poiCities,
    setPoiCities,
    cityBy,
    setCityBy,
    poiInUse,
    setPoiInUse,
    poiRaw,
    setPoiRaw,
    poiCollections,
    poiAppMapShow,
    setPoiAppMapShow,
    poiAppMapOpenLinks,
    setPoiAppMapOpenLinks,
    poiCardTagDialogShow,
    setPoiCardTagDialogShow,
    poiCardTagDialogContent,
    setPoiCardTagDialogContent,
    poiRawTaipeiSpecial,
    poiCollectionsTaipeiSpecial,
    switchText,
    switching,
    loadPois,
    loadPoiCardTags,
    loadPoiBannerBoards,
    switchingTabs,
    setSupportCities,
    gasStationFilter,
    setGasStationFilter,
  };
};

const [PoiContextProvider, usePoiContext] = constate(usePoi);

export { PoiContextProvider, usePoiContext };
